import { render, staticRenderFns } from "./help3_1.vue?vue&type=template&id=1f01901f&"
import script from "./help3_1.vue?vue&type=script&lang=js&"
export * from "./help3_1.vue?vue&type=script&lang=js&"
import style0 from "./help3_1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports